import { render } from "./ClassView.vue?vue&type=template&id=ab59fd94&scoped=true"
import script from "./ClassView.vue?vue&type=script&lang=js"
export * from "./ClassView.vue?vue&type=script&lang=js"

import "./ClassView.vue?vue&type=style&index=0&id=ab59fd94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab59fd94"]])

export default __exports__